import { render } from "./help-center.vue?vue&type=template&id=3b6a4778"
import script from "./help-center.vue?vue&type=script&lang=js"
export * from "./help-center.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__